import templateUrl from 'emun.salesrep/salesrep-expected-orders-future.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepExpectedOrdersFutureController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
    let $ctrl = this;
    var context = $ctrl.context || 'rep';
    var queryCriteria = '';
    $ctrl.config = salesrepConfig;
    $ctrl.label = $ctrl.title || "Last Years Next 60 Days Bookings";
    
    var filter = "RepId";
    if (context == 'vendor') {
      filter = 'VendorId';
    } else if (context == 'subrep') {
      filter = 'SubRepId';
    } else if (context == 'manager') {
      filter = 'ManagerId';
    }
    if ($ctrl.insideSales === 'true') {
      queryCriteria = 'IsInsideSales=true';
          }
    
    $ctrl.underperformers = [];
    $ctrl.utils = utils;
    //var tyDate1 = moment().add('days', -30);
    //var tyDate2 = moment().add('days', 30);
    //var lyDate1 = moment().add('days', -30).add('years',-1);
    //var lyDate2 = moment().add('days', 30).add('years',-1);

    var tyDate1 = moment().add('days', 0);
    var tyDate2 = moment().add('days', 60);
    var lyDate1 = moment().add('days', 0).add('years', -1);
    var lyDate2 = moment().add('days', 60).add('years', -1);

    $ctrl.ytdQuery = createAutoQuery({
      //url: 'QueryOrderTotals.json?dateRange=Custom&startDate=' + tyDate1.format("MM/DD/YYYY") + '&endDate=' + tyDate2.format("MM/DD/YYYY") + '&grouping=strCustomerID&groupingLabel=strCompanyName&' + filter + '=' + $ctrl.rep.id,
      url: 'QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=Custom&startDate=' + tyDate1.format("MM/DD/YYYY") + '&endDate=' + tyDate2.format("MM/DD/YYYY") + '&GroupBy=CustomerID,CustomerName&' + filter + '=' + $ctrl.rep.id + queryCriteria,
      autoLoad: true,
      pageSize: 10000,
      onLoaded: function (ytdResults) {
        $ctrl.lytdQuery = createAutoQuery({
          //                    url: 'QueryOrderTotals.json?dateRange=Custom&startDate=' + lyDate1.format("MM/DD/YYYY") + '&endDate=' + lyDate2.format("MM/DD/YYYY") + '&grouping=strCustomerID&groupingLabel=strCompanyName&' + filter + '=' + $ctrl.rep.id,
          url: 'QuerySalesDailyCustomerTotals.json?Fields=CustomerName,strRanking&Sum=OrderTotal,OrderCount&dateRange=Custom&startDate=' + lyDate1.format("MM/DD/YYYY") + '&endDate=' + lyDate2.format("MM/DD/YYYY") + '&GroupBy=CustomerID,CustomerName,strRanking&' + filter + '=' + $ctrl.rep.id + queryCriteria,
          autoLoad: true,
          pageSize: 10000,
          onLoaded: function (lytdResults) {
            lytdResults.results.forEach(function (lytd) {
              var obj = {};
              obj.label = lytd.customerName;
              obj.id = lytd.customerID;
              obj.lytdSales = lytd.sumOrderTotal;
              obj.ranking = lytd.strRanking;
              var ytd = ytdResults.results.filter(function (obj) {
                return (obj.customerID === lytd.customerID);
              });
              if (ytd.length > 0) {
                obj.ytdSales = ytd[0].sumOrderTotal;
              } else {
                obj.ytdSales = 0;
              }
              obj.diff = obj.ytdSales - obj.lytdSales;
              //							obj.percent = Math.round((obj.ytdSales / obj.lytdSales) * 100);
              var percent = Math.round((obj.ytdSales / obj.lytdSales) * 100);
              if (percent < 100) {
                obj.percent = 100 - percent;
                obj.trend = 'down';
              } else if (percent > 100) {
                obj.percent = percent - 100;
                obj.trend = 'up';
              } else {
                obj.percent = 100;
                obj.trend = 'neutral';
              }
              $ctrl.underperformers.push(obj);
            });
            $ctrl.sortedUnderperformers = _.sortBy($ctrl.underperformers, 'diff').slice(0, 10);
            $ctrl.sortedUnderperformersALL = _.sortBy($ctrl.underperformers, 'diff').slice(0, 100);
          }
        });
      }
    });
  }
  downloadData() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      name: 'Name',
      LYTD: "LYTD Period",
      YTD: "YTD Period",
      Diff: "Diff"
    };

    // format the data
    $ctrl.sortedUnderperformersALL.forEach((item) => {
      itemsFormatted.push({
        name: item.label.replace(/,/g, ''), // remove commas to avoid errors,
        LYTD: item.lytdSales,
        YTD: item.ytdSales,
        Diff: item.diff
      });
    });

    var fileTitle = 'next-60days';
    $ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
  }
}

let SalesRepExpectedOrdersFuture = {
  bindings: {
    rep: '<',
    context: '@',
    insideSales: '@',
    title: '@'
  },
  controller: SalesRepExpectedOrdersFutureController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}


export default SalesRepExpectedOrdersFuture